import styles from "../assets/css/SelectTypeModa.module.css";

const SelectTypeModal = ({ onClose, onSelect }) => {
  return (
    <div className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.box}>
          <div className={styles.text}>Добавить</div>
          <img
            onClick={onClose}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <div className={styles.wrapper}>
          <button className={styles.button} onClick={() => onSelect("type1")}>
            Тип 1
          </button>
          <button className={styles.button} onClick={() => onSelect("type2")}>
            Тип 2
          </button>
          <button className={styles.button} onClick={() => onSelect("type3")}>
            Тип 3
          </button>
          <button className={styles.button} onClick={() => onSelect("type4")}>
            Тип 4
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectTypeModal;
